import React from "react";
import { IDocumentsActive } from "store/lobby/lobby-model";
import { getDocumentLabel } from "utils/functions";
import useAfrDocumentsFlow from "utils/hooks/useAfrDocumentsFlow";

export interface IDocuments {
  documents: Array<IDocumentsActive>;
}

const documentsList = ({ documents }: IDocuments) => {
  const isAfrDocumentsFlow = useAfrDocumentsFlow();

  return (
    <>
      {documents?.map(({ type, value }, i) => (
        <p key={i} className="documentItem">
          {getDocumentLabel(type, isAfrDocumentsFlow)}: {value}
        </p>
      ))}
    </>
  );
};

documentsList.defaultProps = {
  documents: [],
};

export default documentsList;
